import { render, staticRenderFns } from "./DetailMediaPage.vue?vue&type=template&id=684bfad2&"
import script from "./DetailMediaPage.vue?vue&type=script&lang=js&"
export * from "./DetailMediaPage.vue?vue&type=script&lang=js&"
import style0 from "./DetailMediaPage.vue?vue&type=style&index=0&id=684bfad2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports